// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3M6FY","text":"SelectPayment_text__2Nj0G","title":"SelectPayment_title__2Dybb","btn":"SelectPayment_btn__1uvku"};